import { RootState } from 'typesafe-actions';
import { useStore } from 'react-redux';
import { postAsync } from 'features/tracking/api';
import { getCookie } from 'utils';
import { generateIso8601Timestamp } from 'utils/generate-timestamp-iso8601';
import { useEffectOnce } from '@navi-toolbox/hooks';
import { useRef } from 'react';

/**
 * @description Трекинг события просмотра посетителем карточки товара
 */
export const useRRPageView = (productId: string, stockId: string) => {
  const store = useStore<RootState>();

  const trackingSentRef = useRef(false);

  useEffectOnce(() => {
    if (trackingSentRef.current) return;

    const sessionValue = getCookie('rm_session') || '';

    const trackingData = {
      link: { name: 'session', value: sessionValue },
      productId: productId,
      stockId: stockId,
      timestamp: generateIso8601Timestamp(),
    };

    trackingSentRef.current = true;

    postAsync(store, 'tracking/product/view', trackingData, {
      headers: { 'Content-Type': 'application/json' },
    }).catch(() => {
      trackingSentRef.current = false;
    });
  });
};
